import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { AccountRegisterModel } from '../models/schoolRegister.model';
import { PropertyType } from '../models/premise.model';
import { Signup } from '../models/signup.model';

@Injectable()
export class AccountService {

    constructor(private readonly http: HttpClient) {
    }

    registerAccount(details): Observable<AccountRegisterModel> {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.REGISTER_ACCOUNT;
        return this.http.post<AccountRegisterModel>(url , details);
    }

    findAccountById(id) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ACCOUNT_BY_ID + '?accountId=' + id;
        return this.http.get(url);
    }

    getAllAccounts(params, searchBy, filterType) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ALL_ACCOUNT
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy + '&type=' + filterType;
        return this.http.get(url);
    }

    findAllAccounts() {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ACCOUNT;
        return this.http.get(url);
    }

    saveAccount(details): Observable<any> {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.UPDATE_USER_PROFILE;
        return this.http.post(url, details);
    }

    addPropertyType(details): Observable<PropertyType> {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.CREATE_PROPERTY_TYPE;
        return this.http.post<PropertyType>(url , details);
    }

    getAllPropertyType() {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ALL_PROPERTY_TYPE;
        return this.http.get(url);
    }

    getAccountImageName(id) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ACCOUNT_LOGO + '?accountId=' + id;
        return this.http.get(url);
    }

    captureImageByCamera() {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.CAPTURE_IMAGE ;
        return this.http.get(url);
    }

    getPropertyTypeList(params, searchBy) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_PROPERTY_TYPE_LIST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy;
        return this.http.get(url);
    }

    getAccountAddress(accountId) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_ACCOUNT_ADDRESS + '?accountId=' + accountId;
        return this.http.get(url);
    }

    getPlanMasterList() {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_PLAN_LIST;
        return this.http.get(url);
    }
    
    renewPlan(accountId) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.RENEW_PLAN+ '?accountId=' + accountId;
        return this.http.get(url);
    }

    getPlanValidity(accountId) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.GET_PLAN_VALIDITY+ '?accountId=' + accountId;
        return this.http.get(url);
    }

    getAllSuperownerRequest(params, searchBy,filterBy) {
        const url = Constant.REST_URL + Constant.SUPEROWNER + Constant.GET_ALL_SO_REQUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy+'&type='+filterBy;
        return this.http.get(url);
    }

    changeStatus(id,status) {
        const url = Constant.REST_URL + Constant.SUPEROWNER + Constant.CHANGE_STATUS+ '?id=' + id+'&type='+status;
        return this.http.get(url);
    }

    resetPassword(details) {
        const url = Constant.REST_URL + Constant.SUPEROWNER + Constant.RESET_PASSWORD;
        return this.http.post(url , details);
    }

    createSuperownerRequest(details): Observable<Signup> {
        const url = Constant.REST_URL + Constant.SUPEROWNER + Constant.CREATE_SUPEROWNER_REQUEST;
        return this.http.post<Signup>(url , details);
    }

    getAllFlatList(accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_ALL_FLAT_LIST + '?accountId=' + accountId + '&search=';
        return this.http.get(url);
    }

    getAllPremiseLevel(accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_ALL_PREMSIE_LEVEL + '?accountId=' + accountId;
        return this.http.get(url);
    }

    getUpperLevelList(accountId, levelId): Observable<any> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_CHILD_BY_LEVEL_ID + '?accountId=' + accountId + '&levelId=' + levelId;
        return this.http.get(url);
    }

    validateRegistrationCode(code): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_CODE + Constant.VALIDATE_REGISTRATION_CODE + '?code=' + code;
        return this.http.get(url);
    }

    submitRegistrationRequest(details): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.SUBMIT_REGISTRATION_REQUEST;
        return this.http.post(url, details);
    }

    generateRegistrationCode(details): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_CODE + Constant.GENERATE_REGISTRATION_CODE;
        return this.http.post(url, details);
    }

    getRegistrationCodeList(params, accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_CODE + Constant.GET_REGISTRATION_CODE_LIST
        + '?page='
        + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&accountId=' + accountId;
        return this.http.get(url);
    }

    getPendingRequests(params, accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.GET_PENDING_REGISTRATION_REQUESTS
        + '?page='
        + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&accountId=' + accountId;
        return this.http.get(url);
    }

    getRejectedRequests(params, accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.GET_REJECTED_REGISTRATION_REQUESTS
        + '?page='
        + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllRequests(params, accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.GET_ALL_REGISTRATION_REQUESTS
        + '?page='
        + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&accountId=' + accountId;
        return this.http.get(url);
    }

    approveRequest(id, amendedData?: any): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.APPROVE_REGISTRATION_REQUEST + '/' + id;
        const payload = amendedData && Object.keys(amendedData).length > 0 ? amendedData : {};
        return this.http.post(url, payload);
    }

    approveAllRequests(accountId): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.APPROVE_ALL_REGISTRATION_REQUESTS + '?accountId=' + accountId;
        return this.http.post(url, {});
    }

    rejectRequest(id, reason): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.REJECT_REGISTRATION_REQUEST + '/' + id;
        return this.http.post(url, { rejectionReason: reason });
    }

    requestChanges(id, reason): Observable<any> {
        const url = Constant.REST_URL + Constant.REGISTRATION_REQUEST + Constant.REQUEST_CHANGES_REGISTRATION_REQUEST + '/' + id;
        return this.http.post(url, { rejectionReason: reason });
    }
}
